<style type="text/css" media="screen" scoped>
.input-block{
	border: 1px solid #E2E2E2;
	box-sizing: border-box;
	border-radius: 6px;
	width: 48px;
	height: 48px;
	padding: 10px;
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: 900;
	font-size: 18px;
	line-height: 25px;
	text-align: center;
	color: #303030;
}

.input-block:focus{
	border: 2px solid #1DC895 !important;
	/*background-color: #1DC895;*/
	/*color: #FFFF;*/
}
.input-block-wrapper{
	width: 60px;
	height: 60px;
	display: inline-block;
}

</style>

<template>
	<div >
		<div class="text-center">
			<p class="page-title">VERIFY OTP</p>
			<p class="head--text py-2">Enter the 6-digit code sent to {{getOtpToken.mobile}}</p>
		</div>
		<div class="h-100">
			<v-form ref="otp_form"  lazy-validation  @submit.prevent="verify()">
				<v-row justify="center" class="pt-5">
					<v-col cols="10" md="12" class="text-center">
						<otp-block @on-complete="getOtp"/>
<!--						<p>{{otp}}</p>-->
					</v-col>
					<v-col cols="10" md="12" class="text-center">
						<p class="messge-text-green cursor-pointer" @click="resendOtp">{{$lang.RESEND_TO}}{{getOtpToken.mobile}}</p>
					</v-col>
					<v-col cols="10" md="12" class="text-center">
						<v-btn color="primary" class="" :disabled="otp_value.length!=6?true:false" @click="verify()" 
						id="authVerifyOtpBtn"
						type="submit">
						<b>{{$lang.CONTINUE}}</b>
					</v-btn>
				</v-col>
			</v-row>
		</v-form>

	</div>

</div>
</template>
<script type="text/javascript" >
import { mapGetters } from 'vuex';
export default {

	props:["otp"],
	components: {
		OtpBlock: () => import('@/components/common-components/opt-input-box/OtpBlock.vue'),
	},
	data () {
		return {
			otp_value:"",
			enable_flag:true,
		}
	},
	computed: mapGetters({
		getOtpToken: 'auth/getOtpToken'
	}),
	methods:{
		getOtp(otp){
			this.otp_value=otp
			if (this.otp_value.length==6){
				console.log(this.otp_value.length)
				this.verify()
				// document.getElementById("authVerifyOtpBtn").focus()
			}


		},
		/* submit otp and verify data */ 
		verify(){
			if(this.otp_value.length!=6)
				return false

			const self=this;
			var	 form = new URLSearchParams();
			form.append("otp",this.otp_value);

			var header={
				'otp-token':this.getOtpToken.otp_token,
			}
			const successHandler = (response) => {
				if (response.data.success){
					sessionStorage.setItem("token", response.headers.token);
					if (this.getOtpToken.action=="reset"){
						this.$store.dispatch('auth/setAuthStep', 3)
					}
					else{
						this.$store.dispatch('auth/setAuthStep', 1)
						self.$router.push({name:"overview"})
						this.$store.dispatch('setWelcomeDialog',true)

					}
				}
			};
			self.request_POST(self,self.$urls.VERIFY,form,successHandler,header)

		},
		resendOtp(){

			const self=this;

			var	 form = new URLSearchParams();

			var header={
				'otp-token':this.getOtpToken.otp_token,
			}
			const successHandler = (response) => {
				if (response.data.success){
					let text="OTP resent"
					this.$store.dispatch('snackbar/setSnackbar', {flag:true, text, color:"success" })
					// localStorage.setItem("token", response.headers.token);
					// self.$router.push({name:"overview"})
				}
			};
			self.request_GET(self,self.$urls.RESEND_OTP,form,successHandler,header)

		}
		




	}

}
</script>